module.exports = "<div *ngIf=\"errorMessage !== null\" [style.fontSize]=\"fontSize\">* {{errorMessage}}</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/validation/error-messages/error-messages.html
// module id = ./src/app/validation/error-messages/error-messages.html
// module chunks = main